import { render } from "./RegistrationView.vue?vue&type=template&id=487655bb&scoped=true&ts=true"
import script from "./RegistrationView.vue?vue&type=script&lang=ts"
export * from "./RegistrationView.vue?vue&type=script&lang=ts"

import "./RegistrationView.vue?vue&type=style&index=0&id=487655bb&scoped=true&lang=css"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-487655bb"]])

export default __exports__